import { render, staticRenderFns } from "./disUse_newPrepay.vue?vue&type=template&id=32ca61ee&scoped=true"
import script from "./disUse_newPrepay.vue?vue&type=script&lang=js"
export * from "./disUse_newPrepay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ca61ee",
  null
  
)

export default component.exports